// utils/encryption.js
import CryptoJS from "crypto-js";

// Store this securely (e.g. env var, not in code)
const SECRET_KEY =
  process.env.REACT_APP_ENCRYPTION_KEY || "dsfdesvfde3rgbr234fwerfefwfcd";

export function encryptField(value) {
  return CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
}

export function decryptField(cipherText) {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    return null;
  }
}
